import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PORTAL_URL } from '../config/links';
import { useTranslation } from '../context/LanguageContext';
import './Footer.css';

export default function Footer() {
  const { t } = useTranslation();

  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) { setSubscribed(true); setEmail(''); }
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand-col">
              <Link to="/" className="footer-logo">
                <img src="/logo.png" alt="ThirdEye Cybersecurity" className="footer-logo-img" />
                <div>
                  <div className="footer-brand-name">ThirdEye</div>
                  <div className="footer-brand-sub">Cybersecurity</div>
                </div>
              </Link>
              <p className="footer-tagline">
                Shiddhipriya IT Consulting INC DBA ThirdEye Cyber Security
              </p>
              <div className="footer-socials">
                <a href="https://facebook.com" aria-label={t('agency.footer_facebook_label', 'Facebook')} className="social-link" target="_blank" rel="noreferrer">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" /></svg>
                </a>
                <a href="https://twitter.com" aria-label={t('agency.footer_twitter_label', 'Twitter')} className="social-link" target="_blank" rel="noreferrer">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" /></svg>
                </a>
                <a href="https://instagram.com" aria-label={t('agency.footer_instagram_label', 'Instagram')} className="social-link" target="_blank" rel="noreferrer">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" /><circle cx="12" cy="12" r="5" /><circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" /></svg>
                </a>
                <a href="https://linkedin.com" aria-label={t('agency.footer_linkedin_label', 'LinkedIn')} className="social-link" target="_blank" rel="noreferrer">
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" /><circle cx="4" cy="4" r="2" /></svg>
                </a>
              </div>
              <p className="footer-copyright">{t('agency.footer_copyright_msg', '© {year} ThirdEye Cybersecurity. All rights reserved.', { year: new Date().getFullYear() })}</p>
            </div>

            <div className="footer-links-col">
              <h4 className="footer-heading">{t('agency.footer_quick_links_title', 'Quick Links')}</h4>
              <ul className="footer-nav">
                <li><Link to="/">{t('agency.footer_home_label', 'Home')}</Link></li>
                <li><Link to="/training">{t('agency.footer_training_label', 'Training')}</Link></li>
                <li><Link to="/staff-augmentation">{t('agency.footer_staff_augmentation_label', 'Staff Augmentation')}</Link></li>
                <li><Link to="/it-services">{t('agency.footer_it_services_label', 'IT Services')}</Link></li>
                <li><Link to="/enterprise-ai">{t('agency.footer_enterprise_ai_label', 'Enterprise AI')}</Link></li>
                <li><Link to="/jobs">{t('agency.footer_jobs_label', 'Jobs')}</Link></li>
                <li><Link to="/contact">{t('agency.footer_contact_us_label', 'Contact Us')}</Link></li>
                <li><a href={PORTAL_URL} target="_blank" rel="noopener noreferrer">{t('agency.footer_learning_portal_label', 'Learning Portal ↗')}</a></li>
              </ul>
            </div>

            <div className="footer-links-col">
              <h4 className="footer-heading">{t('agency.footer_services_title', 'Services')}</h4>
              <ul className="footer-nav">
                <li><Link to="/it-services">{t('agency.footer_cyber_security_label', 'Cyber Security')}</Link></li>
                <li><Link to="/it-services">{t('agency.footer_cloud_solutions_label', 'Cloud Solutions')}</Link></li>
                <li><Link to="/it-services">{t('agency.footer_it_consulting_label', 'IT Consulting')}</Link></li>
                <li><Link to="/training">{t('agency.footer_ceh_certification_label', 'CEH Certification')}</Link></li>
                <li><Link to="/training">{t('agency.footer_cissp_training_label', 'CISSP Training')}</Link></li>
                <li><Link to="/staff-augmentation">{t('agency.footer_security_analysts_label', 'Security Analysts')}</Link></li>
              </ul>
            </div>

            <div className="footer-newsletter-col">
              <h4 className="footer-heading">{t('agency.footer_stay_updated_title', 'Stay Updated')}</h4>
              <p className="footer-newsletter-desc">{t('agency.footer_newsletter_desc', 'Get the latest cybersecurity insights, training updates, and job opportunities.')}</p>
              {subscribed ? (
                <div className="subscribed-msg">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
                  {t('agency.footer_subscribed_msg', 'Thanks for subscribing!')}
                </div>
              ) : (
                <form className="newsletter-form" onSubmit={handleSubscribe}>
                  <input
                    type="email"
                    placeholder={t('agency.footer_email_placeholder', 'Your email address')}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    className="newsletter-input"
                  />
                  <button type="submit" className="newsletter-btn">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" /></svg>
                  </button>
                </form>
              )}
              <div className="footer-policy-links">
                <Link to="/privacy-policy">{t('agency.footer_privacy_policy_label', 'Privacy Policy')}</Link>
                <Link to="/terms-of-service">{t('agency.footer_terms_of_service_label', 'Terms of Service')}</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

    </footer>
  );
}
